import { AppConfig } from "../utils/appConfig";

const PLACEHOLDER_PATTERN = /^##.*##$/;

export type NewRelicConfigValidation = {
  shouldInitialize: boolean;
  missingFields: string[];
};

const REQUIRED_FIELDS = [
  "new_relic_browser_application_id",
  "new_relic_browser_license_key",
  "new_relic_browser_account_id",
  "new_relic_browser_trust_key",
  "new_relic_browser_agent_id",
  "new_relic_browser_beacon"
] as const;

type RequiredField = (typeof REQUIRED_FIELDS)[number];

const isPlaceholder = (value?: string): boolean => {
  if (!value) {
    return true;
  }

  return PLACEHOLDER_PATTERN.test(value);
};

export const isNewRelicBrowserEnabled = (enabled?: boolean | string): boolean => {
  return enabled === true || enabled === "true";
};

export const validateNewRelicConfig = (config: AppConfig): NewRelicConfigValidation => {
  if (!isNewRelicBrowserEnabled(config.new_relic_browser_enabled)) {
    return { shouldInitialize: false, missingFields: [] };
  }

  const missingFields = REQUIRED_FIELDS.filter((field: RequiredField) => isPlaceholder(config[field]));

  return {
    shouldInitialize: missingFields.length === 0,
    missingFields: [...missingFields]
  };
};
